/** @format */
import { css } from 'styled-components';

/**
 * Base styles for the sticky header component
 *
 * @param {StickyHeaderProps} props The sticky header properties object
 * */
const baseStyles = () => css`
    overflow: hidden;
    position: absolute;
    width: 100%;
    z-index: -1;
    /**
     * This div may contain elements with drop shadows that we want
     * to be able to click through.
     */
    pointer-events: none;

    /**
     * Restore click events to direct descendants by default. They
     * can opt out within their own styles.
     */
    & > * {
        pointer-events: all;
    }
`;

/**
 * The sticky header component styles
 *
 * @param {StickyHeaderProps} props The sticky header properties object
 * */
export const styles = () => css`
    ${baseStyles()}
`;
